import type { AdTier } from '../../hooks/useAdTier'

export interface AdTierConfig {
    baseAdUnitPath: string
    slots: Array<{
        slotIdSuffix: string
        position: string
        size: googletag.GeneralSize
    }>
    tierTargeting?: Record<string, string | string[]>
}

export const adTierConfigs: Record<AdTier, AdTierConfig> = {
  under25: {
    baseAdUnitPath: '/137419494/smartasset//funnel',
    slots: [
      { slotIdSuffix: '1', position: 'funnel1', size: 'fluid' as googletag.GeneralSize },
      { slotIdSuffix: '2', position: 'funnel2', size: 'fluid' as googletag.GeneralSize },
      { slotIdSuffix: '3', position: 'funnel3', size: 'fluid' as googletag.GeneralSize }
    ]
  },
  under100K: {
    baseAdUnitPath: '/137419494/smartasset//funnel',
    slots: [
      { slotIdSuffix: '1', position: 'funnel1', size: 'fluid' as googletag.GeneralSize },
      { slotIdSuffix: '2', position: 'funnel2', size: 'fluid' as googletag.GeneralSize },
      { slotIdSuffix: '3', position: 'funnel3', size: 'fluid' as googletag.GeneralSize },
      { slotIdSuffix: 'pixel', position: 'under100K', size: [1, 1] as googletag.GeneralSize }
    ]
  }
}
